import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useDeleteEstablishmentCompanyMaintenanceRequiredDocuments } from "@/features/establishments/hooks/maintenanceModels/useDeleteEstablishmentCompanyMaintenanceRequiredDocuments";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

interface DeleteMaintenanceRequiredDocumentProps {
  establishmentCompany?: EstablishmentCompanyData;
  maintenanceRequiredDocumentId: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const DeleteMaintenanceRequiredDocument = ({
  establishmentCompany,
  maintenanceRequiredDocumentId,
  isOpen,
  setIsOpen,
}: DeleteMaintenanceRequiredDocumentProps) => {
  const queryClient = useQueryClient();
  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    mutate: deleteMaintenanceRequiredDocument,
    isPending: deleteMaintenanceRequiredDocumentIsPending,
  } = useDeleteEstablishmentCompanyMaintenanceRequiredDocuments({
    establishmentCompanyId: establishmentCompany?.id,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['establishmentCompany', establishmentCompany?.id] });

      setIsOpen(false);
    },
    onError: FormTransformers.errorsTransformer({
      setMessages,
    }),
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        useCancellableFooter
        confirmButtonClassName="rounded-br-lg"
        cancelButtonClassName="rounded-bl-lg"
        onConfirm={() => deleteMaintenanceRequiredDocument(maintenanceRequiredDocumentId)}
        confirmButtonIsLoading={deleteMaintenanceRequiredDocumentIsPending}
        title="Você tem certeza?"
        subtitle="Essa ação não é reversível."
        titleClass="text-2xl"
        subtitleClassName="text-base mt-1"
        showClose={false}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default DeleteMaintenanceRequiredDocument;
